module.exports = __webpack_public_path__ + "img/005-orbit-1.65ba7950.svg";